import { render, staticRenderFns } from "./SqlQueryDialog.vue?vue&type=template&id=38271fc4&scoped=true&"
import script from "./SqlQueryDialog.vue?vue&type=script&lang=js&"
export * from "./SqlQueryDialog.vue?vue&type=script&lang=js&"
import style0 from "./SqlQueryDialog.vue?vue&type=style&index=0&id=38271fc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38271fc4",
  null
  
)

export default component.exports